export default __webpack_public_path__ + "static/media/rakhi15.992ec3fd.jpeg";